import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root',
})
export class StorageService {
    public isLocalStorageAvailable: boolean;
    private values: { [key: string]: string } = {};

    constructor() {
        try {
            const test = 'test';
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            this.isLocalStorageAvailable = true;
        } catch (e) {
            this.isLocalStorageAvailable = false;
            console.warn('WARNING: LocalStorage is unavailable');
        }
    }
    public getItem(key: string): string | null {
        if (this.isLocalStorageAvailable) {
            return localStorage.getItem(key);
        } else {
            return this.values[key] || null;
        }
    }
    public setItem(key: string, value: string): void {
        this.values[key] = value;
        if (this.isLocalStorageAvailable) {
            localStorage.setItem(key, value);
        }
    }
    public removeItem(key: string): void {
        delete this.values[key];
        if (this.isLocalStorageAvailable) {
            localStorage.removeItem(key);
        }
    }
}
